import store from 'store';
import React from 'react';
import ReactDOM from 'react-dom';
import { isSupported } from 'twilio-video';
import './index.css';
import BrowserNotSupported from './components/BrowserNotSupported';
import showLogin from './showLogin';
import showContacts from './showContacts';
import registerServiceWorker from './registerServiceWorker';
import { getCurrentLang } from './utils';

async function logCameras() {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const cameras = devices.filter(device => device.kind === 'videoinput');
  console.log('Total Cameras:', cameras.length);
  cameras.forEach(camera => console.log(camera));
}

async function startApp() {
  logCameras();
  // load and set dictionary
  const lang = getCurrentLang();
  console.log('Language:', lang);
  const locale = await import(`./locales/${lang}.json`);
  global.dictionaries = { calling: locale.dictionary };
  // check if browser supports WebRTC
  if (!isSupported) {
    ReactDOM.render(<BrowserNotSupported />, document.getElementById('root'));
    return;
  }
  // check if user logged in
  if (!store.get('credentials')) {
    console.log('Credentials not found. Showing Login.');
    showLogin();
  } else {
    console.log('Credentials present. Showing Contacts.');
    showContacts();
  }
}

startApp();

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js